import { toast } from "react-toastify";

// Constants
const MAX_FILE_SIZE_KB = 5 * 1024; // 5MB in KB
const ALLOWED_EXTENSIONS = ['.txt', '.xml', '.json', 'text/plain', 'text/xml', 'application/json'];
const MAX_FILES_COUNT = 10000; // Maximum file limit

// Error messages
const ERROR_MESSAGES = {
  FILE_FORMAT: "Only XML, JSON, and TEXT files are supported.",
  FILE_SIZE: "File size exceeds the 5MB limit.",
  MAX_FILES: `You can upload up to ${MAX_FILES_COUNT} files.`,
};

class UploadService {
  // Validate file extensions against allowed types
  validateFileExtensions = (files: any, allowedExtensions = ALLOWED_EXTENSIONS) => {
    return files.every((file: any) => allowedExtensions.includes(file.type));
  };

  // Check the total size of the files
  checkFileSize = (files: any, previousSize = 0) => {

    let isValid = false;
    let totalSize = 0;
    for (const item of files) {
      totalSize += item.size;
    }
    totalSize = totalSize / 1024;
    if (previousSize !== undefined) {
      totalSize += previousSize;
    } else {
      previousSize = 0; // Default to zero if not provided
    }
    //in KB
    if (totalSize < MAX_FILE_SIZE_KB) {
      isValid = true;
      return { isValid, totalSize };
    } else {
      isValid = false;
      totalSize = previousSize;
      return { isValid, totalSize };
    }

    // let totalSize = files.reduce((acc:any, file:any) => acc + file.size, previousSize); // This will throw an error if `files` is not an array.
    // totalSize = totalSize / 1024; // Convert size to KB

    // return {
    //   isValid: totalSize <= MAX_FILE_SIZE_KB,
    //   totalSize,
    // };
  };

  // Delete a file by index
  deleteFile = (files: any, index: any) => {
    const newFiles = [...files]; // Create a copy to avoid direct mutation
    newFiles.splice(index, 1); // Remove the file at the index
    return newFiles;
  };

  // Remove duplicate files based on file name
  removeDuplicateFiles = (existingFiles: any, uploadedFiles: any, callback: Function) => {
    const duplicateFiles: any = [];
    const filteredFiles: any = [];

    uploadedFiles.forEach((file: any) => {
      const isDuplicate = existingFiles.some((existingFile: any) => existingFile.name === file.name);
      if (isDuplicate) {
        duplicateFiles.push(file);
      } else {
        filteredFiles.push(file);
      }
    });

    // Callback will handle duplicates and filtered files
    callback(duplicateFiles, filteredFiles);
  };



  // Validate the file upload process
  validateFileUpload = (files: any, uploadedFiles: any, isSsh = true, previousSize = 0) => {
    const fileSizeResult = this.checkFileSize(uploadedFiles, previousSize);
    const areExtensionsValid = isSsh ? this.validateFileExtensions(files) : this.validateFileExtensions(uploadedFiles);
    const totalFilesCount = files.length + uploadedFiles.length;

    if (!fileSizeResult.isValid) {
      toast.error(ERROR_MESSAGES.FILE_SIZE);
      return { isValid: false, totalSize: fileSizeResult.totalSize };
    }

    if (!areExtensionsValid) {
      toast.error(ERROR_MESSAGES.FILE_FORMAT);
      return { isValid: false, totalSize: fileSizeResult.totalSize };
    }

    if (totalFilesCount > MAX_FILES_COUNT) {
      toast.error(ERROR_MESSAGES.MAX_FILES);
      return { isValid: false, totalSize: fileSizeResult.totalSize };
    }

    return { isValid: true, totalSize: fileSizeResult.totalSize };
  };
}

const uploadService = new UploadService();
export default uploadService;
